module.exports = __webpack_public_path__ + "static/media/17_profile_picture.1ca0b0cb.png";